import { API_URL } from "@constants/api.constants";
import { PRIMARY_KEY } from "@constants/app.constants";
import { formatDate } from "@utils/date.util";

const keyColumn = PRIMARY_KEY;

const tableTitle = "Uploads";
const menuUrl = "inventory/uploads";

const tableColumn = [
  {
    id: "category_name",
    numeric: false,
    disablePadding: false,
    label: "Category Name",
  },
  {
    id: "file_path",
    numeric: false,
    disablePadding: false,
    label: "File Path",
    formatData: (filePath) => {
      if (!filePath) return "N/A";

      const fileName = filePath.split("/").pop();

      const handleDownload = async (e) => {
        e.stopPropagation();
        try {
          const response = await fetch(`${API_URL}/download-inventory-file`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/octet-stream",
            },
            body: JSON.stringify({
              file_path: filePath,
            }),
          });

          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || "Failed to download file");
          }

          const blob = await response.blob();

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } catch (error) {
          console.error("Error downloading file:", error);
          alert(`Error downloading file: ${error.message}`);
        }
      };

      return (
        <span
          onClick={handleDownload}
          style={{
            // color: "#1976d2",
            cursor: "pointer",
            // textDecoration: "underline",
          }}
        >
          {fileName}
        </span>
      );
    },
  },

  {
    id: "total_count",
    numeric: true,
    disablePadding: false,
    label: "Total Count",
    formatData: (val) => val || 0,
  },
  {
    id: "error_count",
    numeric: true,
    disablePadding: false,
    label: "Error Count",
    formatData: (errorLog) => {
      if (!errorLog) return 0;
      try {
        const errors = JSON.parse(errorLog);
        return errors ? errors.length : 0;
      } catch {
        return 0;
      }
    },
  },
  {
    id: "error_log",
    numeric: false,
    disablePadding: false,
    label: "Error Log",
    formatData: (errorLog) => {
      if (!errorLog) return "No errors";
      try {
        const errors = JSON.parse(errorLog);
        if (!errors || errors.length === 0) return "No errors";

        return (
          <div className="text-truncate" style={{ maxWidth: "300px" }}>
            {errors.slice(0, 2).map((error, index) => (
              <div key={index} className="text-danger small">
                {error}
              </div>
            ))}
            {errors.length > 2 && (
              <div className="text-muted small">
                ...and {errors.length - 2} more
              </div>
            )}
          </div>
        );
      } catch {
        return "Invalid error data";
      }
    },
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDate,
    sort: true,
  },
];

const breadCrumbs = [
  { name: "File Upload History", menu_url: "/inventory/uploads" },
];

const filters = ({categories}) => [
  {
    name: "category_id",
    id: "category_id",
    label: "Category",
    value: "",
    type: "SELECT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
    options: categories,
  },
];

export { tableTitle, keyColumn, tableColumn, breadCrumbs, menuUrl, filters };
